export type DirecaoPosicao = "cima" | "baixo";

/**
 * Troca um item de lugar com o vizinho, achando o item pelo uuid.
 *
 * Pelo uuid e não pelo índice da linha: as tabelas de massa, borda e sabor
 * filtram por nome, e com filtro ativo o índice do que está na tela não é o
 * índice do array que vai ser salvo — mover pelo índice visível embaralharia
 * outra coisa.
 *
 * A ordem do array é a ordem de exibição (no cardápio, no PDV e no chat), então
 * é ela que a tela reordena; nos extremos, devolve o mesmo array.
 */
export const trocarPosicaoPorUuid = <T extends { uuid: string }>(
    itens: T[],
    uuid: string,
    direcao: DirecaoPosicao
): T[] => {
    const index = itens.findIndex(item => item.uuid === uuid);
    if (index === -1) return itens;

    const destino = direcao === "cima" ? index - 1 : index + 1;
    if (destino < 0 || destino >= itens.length) return itens;

    const reordenados = [...itens];
    [reordenados[index], reordenados[destino]] = [reordenados[destino], reordenados[index]];

    return reordenados;
}
